import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconFacebookDark = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.6663 11.5604H13.7497L14.583 8.22705H11.6663V6.56038C11.6663 5.70257 11.6663 4.89372 13.333 4.89372H14.583V2.0938C14.3116 2.05776 13.2855 1.97705 12.2021 1.97705C9.94001 1.97705 8.33301 3.35777 8.33301 5.89348V8.22705H5.83301V11.5604H8.33301V18.6437H11.6663V11.5604Z",
		fill: "#03314B"
	})
});
export default SvgIconFacebookDark;
